import type { SeedingItem } from '@/app/(activity)/campaigns/[slug]/types';

/** 列表项稳定 key（接口可能只返回 item_id，id 可能为空或重复） */
export function getSeedingItemKey(item: SeedingItem, index: number): string {
  const id = item.item_id ?? item.id;
  return id != null ? `seeding-item-${id}` : `seeding-item-index-${index}`;
}
